import { Dispatch } from 'redux'

import * as Api from 'redux/api/CustomFields'

import { toggleSnackbarOpen } from '../Snackbar'
import { SnackbarMessage } from 'types/GlobalSnackbar'
import { useThunkActions } from '../useThunkActions'

import * as actions from './actions'

export function tryGetAllCustomFields(dispatch: Dispatch) {
  dispatch(actions.getAll())

  Api.getAll()
    .then((response) => dispatch(actions.getAllSuccess(response.data.data)))
    .catch(() => dispatch(actions.getAllFailed()))
}

function tryCreateCustomField(fieldName: string) {
  return (dispatch: Dispatch) => {
    dispatch(actions.create())

    Api.create(fieldName)
      .then((response) => {
        dispatch(actions.createSuccess(response.data.data))

        dispatch(toggleSnackbarOpen(SnackbarMessage.TagCreated))
      })
      .catch(() => {
        dispatch(actions.createFailed())

        dispatch(toggleSnackbarOpen(SnackbarMessage.TagCreatedFailed))
      })
  }
}

export const useCustomFieldActions = () => {
  return {
    tryGetAllCustomFields: useThunkActions(tryGetAllCustomFields),
    tryCreateCustomField: useThunkActions(tryCreateCustomField)
  }
}
